import { render, staticRenderFns } from "./PqrIndicators.vue?vue&type=template&id=4253aeb5&"
import script from "./PqrIndicators.vue?vue&type=script&lang=js&"
export * from "./PqrIndicators.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports